import React from 'react'
import './incubators.css'
import C2wLogoHolder from '../../../common/C2wHome/incubators/logoHolder';
import { AnimatePresence, motion } from 'framer-motion';

function C2wIncubators( { isVisible } ) {

    const mobileArr = [
        'flutterSvg',
        'flutterSvg2'
    ]

    const backendArr = [
        'javaLogoSvg',
        'springLogoSvg'
    ]

    const webArr = [
        'reactLogoSvg',
        'nodeSvg',
        'nextJsSvg',
        'jsSvg'
    ]

    return (
        <div className='C2wIncubators_ctn'>
            <AnimatePresence>
                <motion.div className='C2wIncubators_ctn_content_motion'
                    initial={ { x: -600, scale: 0, opacity: 0 }}
                    animate={ isVisible ? { x: 0, scale: 1, opacity: 1 } : {}}
                    transition={{ delay: 0, duration: 1, ease: [0.25, 0.8, 0.25, 1] }}>
                    <div className='C2wIncubators_ctn_content'>
                        <div className='C2wIncubators_ctn_content_logo'>
                            <img src='/assets/images/landing/incubators.svg' alt='inc-logo' />
                        </div>
                        <div className='C2wIncubators_ctn_contnt_heading_hold'>
                            <div className='C2wIncubators_main_heading'>{'We deliver training & internship programs'}</div>
                            <div className='C2wIncubators_submain_heading'>{'Live projects | Digital logbook | 1:1 Mentorship | Training & Internship'}</div>
                        </div>
                        <div className='C2wIncubators_ctn_contnt_btns'>
                            <a href='https://www.incubators.town/' target='_blank' style={{ textDecoration: 'none' }}>
                                <div className='C2wIncubators_ctn_contnt_btnspan'>{'Know more'}
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 17L17 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7 7H17V17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </motion.div>
                </AnimatePresence>
                <AnimatePresence>
                    <motion.div className='C2wIncubators_ctn_cardholder_motion'
                        initial={{ x: 600, scale: 0, opacity: 0 }}
                        animate={ isVisible ? { x: 0, scale: 1, opacity: 1 } : {}}
                        transition={{ delay: 0, duration: 1.5, ease: [0.25, 0.8, 0.25, 1] }}>
                        <div className='C2wIncubators_ctn_cardholder'>
                            <svg className='C2wSvgStar1' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.5564 0.246094L18.1589 11.2L29.1128 14.8025L18.1589 18.405L14.5564 29.3589L10.9539 18.405L0 14.8025L10.9539 11.2L14.5564 0.246094Z" fill="#F34D4D" />
                            </svg>
                            <svg className='C2wSvgCircle1' width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10.7775" cy="11.5548" r="10.7032" fill="#B09FEA" />
                                <circle cx="10.7775" cy="11.5548" r="10.7032" fill="url(#paint0_linear_5869_10557)" />
                                <defs>
                                    <linearGradient id="paint0_linear_5869_10557" x1="6.12125" y1="20.5188" x2="17.8957" y2="3.62216" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFB320" />
                                        <stop offset="1" stop-color="#FFF733" />
                                    </linearGradient>
                                </defs>
                            </svg>

                            <svg className='C2wSvgStar2' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.1619 0.492188L18.7644 11.4461L29.7183 15.0486L18.7644 18.6511L15.1619 29.605L11.5594 18.6511L0.605469 15.0486L11.5594 11.4461L15.1619 0.492188Z" fill="white" fill-opacity="0.37" />
                            </svg>

                            <svg className='C2wSvgCircle2' width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="15.5213" cy="14.7088" r="14.5564" fill="#0A91F2" />
                                <circle cx="15.5213" cy="14.7088" r="14.5564" fill="url(#paint0_linear_5869_10556)" />
                                <defs>
                                    <linearGradient id="paint0_linear_5869_10556" x1="21.7482" y1="4.51927" x2="1.03533" y2="11.3607" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#8FBFEB" />
                                        <stop offset="1" stop-color="#207CD1" />
                                    </linearGradient>
                                </defs>
                            </svg>

                            <div className='C2wIncubators_ctn_cardholder1'>
                                <div className='C2wTech_card C2wTech_card1'  >
                                    <div className='C2wTech_cardanimate'>
                                        <span>{'Mobile App Development'}</span>
                                        <div className='C2wTech_card_logo_holder'>
                                            {mobileArr && mobileArr?.map((img) => (
                                                <C2wLogoHolder imgSvg={img} />
                                            ))}
                                        </div>
                                    </div>

                                    <img src='/assets/images/landing/incuLeftArrow.svg' className='leftarrow_img' alt='logo-arrow' />
                                </div>
                                <div className='C2wTech_card C2wTech_card2' >
                                    <div className='C2wTech_cardanimate'>

                                        <span>{'Web Development'}</span>
                                        <div className='C2wTech_card_logo_holder'>
                                            {webArr && webArr?.map((img) => (
                                                <C2wLogoHolder imgSvg={img} />
                                            ))}
                                        </div>
                                    </div>
                                    <img src='/assets/images/landing/incuBottomArrow.svg' className='incuBottomArrowSvg' alt='logo-arrow' />
                                </div>
                            </div>
                            <div className='C2wIncubators_ctn_cardholder2'>
                                <div className='C2wTech_card C2wTech_card3'  >
                                    <div className='C2wTech_cardanimate'>
                                        <span>{'Backend Development'}</span>
                                        <div className='C2wTech_card_logo_holder'>
                                            {backendArr && backendArr?.map((img) => (
                                                <C2wLogoHolder imgSvg={img} />
                                            ))}
                                        </div>
                                    </div>
                                    <img src='/assets/images/landing/incuRightArrowSvg.svg' className='incuRightArrowSvg' alt='logo-arrow' />
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </AnimatePresence>
        </div>
    )
}

export default C2wIncubators;
